/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const updateHierarchy = /* GraphQL */ `
  mutation UpdateHierarchy($input: HierArray) {
    updateHierarchy(input: $input) {
      result
      hiers {
        agentNum
        AgencyCode
        ManagerAgentNumPrimary
        AOAgentNumPrimary
        GLHierarchyTypeRoleID
        IsUnassigned
        CreatedBy
      }
    }
  }
`;
export const createAgency = /* GraphQL */ `
  mutation CreateAgency($input: AgencyInput) {
    createAgency(input: $input) {
      agency
      sync
      agencyCode
      addr
      phone
    }
  }
`;
export const updateAgency = /* GraphQL */ `
  mutation UpdateAgency($input: AgencyInput) {
    updateAgency(input: $input)
  }
`;
export const updateAgencyAddress = /* GraphQL */ `
  mutation UpdateAgencyAddress($input: AgencyInput) {
    updateAgencyAddress(input: $input)
  }
`;
export const updateAgencyPhone = /* GraphQL */ `
  mutation UpdateAgencyPhone($input: AgencyInput) {
    updateAgencyPhone(input: $input)
  }
`;
export const broadcastRevoke = /* GraphQL */ `
  mutation BroadcastRevoke($input: agentIn) {
    broadcastRevoke(input: $input) {
      id
      FirstName
      MiddleName
      LastName
      TMKClientID
      AgencyCode
      AgentNum
      AgentNumPrimary
      ManagerAgentNumPrimary
      AOAgentNumPrimary
      IsUnassigned
      ModifiedDate
      RoleId
      RoleAbbr
      TerminationDate
    }
  }
`;
export const replaceAO = /* GraphQL */ `
  mutation ReplaceAO($input: ReplacementsInput) {
    replaceAO(input: $input)
  }
`;
export const replaceAOWithNonAO = /* GraphQL */ `
  mutation ReplaceAOWithNonAO($input: ReplacementsInput) {
    replaceAOWithNonAO(input: $input)
  }
`;
export const broadcastUnlock = /* GraphQL */ `
  mutation BroadcastUnlock($input: AgencyEditsBroadcast) {
    broadcastUnlock(input: $input) {
      AOAgentNum
      Msg
      Editing
      From
      FromName
      To
      FromSession
      ToSession
    }
  }
`;
